import { useCallback } from 'react'
import { ACTION_TYPE, PRODUCT_PROPERTY } from 'general/constants/AppConstants'
import Utils from 'general/utils/Utils'
import { useAppSelector } from 'hooks/useRedux'
import calculateExchangedMoneyTableData from '../Function/CalculateTableData'
import { selectFormatNumber } from 'features/System/screens/SystemConfiguration/SystemConfigurationSlice'

export function useInvoiceCalculations({
  formik,
  actionType,
  setIsChangeTable,
  isChangeTaxRate,
  isChangeTable,
  roundingConfig,
  tableData,
  setTableData,
}) {
  const { values, setFieldValue } = formik
  // const { formatNumber } = useAppSelector((state) => state?.systemConfig)
  const formatNumber = useAppSelector(selectFormatNumber)

  const roundingConfigDataNew = (defaultConfig) => {
    if (!formatNumber) return null
    return ['VNĐ', 'VND'].includes(formik.values.currency)
      ? formatNumber[defaultConfig]
      : formatNumber.exchangeTotalCost
  }

  const calculateAndSetFinalExchangedMoney = useCallback(
    (
      exchangeRate,
      discountMoney,
      total,
      taxMoney,
      totalAfterTax,
      totalTaxReduction,
    ) => {
      if (typeof exchangeRate === 'string') {
        exchangeRate = Utils.parseFormattedNumberToFloat(exchangeRate)
      }
      setFieldValue('exchangedDiscountMoney', discountMoney * exchangeRate)
      setFieldValue('exchangedTotalAfterTax', totalAfterTax * exchangeRate)
      setFieldValue('exchangedTotal', total * exchangeRate)
      setFieldValue('exchangedTaxMoney', taxMoney * exchangeRate)
      setFieldValue(
        'exchangedTotalTaxReduction',
        totalTaxReduction * exchangeRate,
      )
    },
    [setFieldValue],
  )

  const calculateAndSetFinalMoney = useCallback(
    (newTableData) => {
      let { exchangeRate } = values
      let total = 0
      let taxMoney = 0
      let totalAfterTax = 0
      let discountMoney = 0
      let totalTaxReduction = 0
      const commonTaxRate =
        !values.multipleTaxRate &&
        values.taxRate != null &&
        (values.taxType === 1 ||
          values.taxType === 2 ||
          (values.taxType === 3 && !values.multipleTaxRate)) &&
        parseInt(values?.serial?.charAt(0)) === 1
          ? values.taxRate
          : null
      const numericCommonTaxRate = ['0', '5', '8', '10'].includes(
        String(commonTaxRate),
      )
      newTableData.forEach((item) => {
        if (numericCommonTaxRate) {
          item.taxRate = commonTaxRate
          item.taxMoney =
            (((item?.totalUnitPrice ?? 0) - (item?.discountMoney ?? 0)) *
              parseInt(commonTaxRate)) /
            100
        }
        if (item?.taxMoney) {
          switch (item?.type) {
            case PRODUCT_PROPERTY.GOODS_SERVICE: // type là hàng hoá/ dịch vụ + bình thường
            case PRODUCT_PROPERTY.SPECIAL_GOODS:
              taxMoney += item?.taxMoney
              break
            case PRODUCT_PROPERTY.PROMOTION: // type là hàng khuyến mại không + tổng tiền
              // taxMoney += item?.taxMoney;
              break
            case PRODUCT_PROPERTY.DISCOUNT: // type là chiếu khấu thương mại - bớt đi giá trị
              taxMoney -= item?.taxMoney
              break
            default:
              break
          }
        }
        if (item?.totalUnitPrice) {
          switch (item?.type) {
            case PRODUCT_PROPERTY.GOODS_SERVICE: // type là hàng hoá/ dịch vụ + bình thường
            case PRODUCT_PROPERTY.SPECIAL_GOODS:
              total += item?.totalUnitPrice
              break
            case PRODUCT_PROPERTY.PROMOTION: // type là hàng khuyến mại không + tổng tiền
              break
            case PRODUCT_PROPERTY.DISCOUNT: // type là chiếu khấu thương mại - bớt đi giá trị
              total = total - item?.totalUnitPrice
              break
            default:
              break
          }
        }
        if (item?.taxReduction) {
          switch (item?.type) {
            case PRODUCT_PROPERTY.GOODS_SERVICE: // type là hàng hoá/ dịch vụ + bình thường
            case PRODUCT_PROPERTY.SPECIAL_GOODS:
              totalTaxReduction += item?.taxReduction
              break
            case PRODUCT_PROPERTY.PROMOTION: // type là hàng khuyến mại không + tổng tiền
              break
            case PRODUCT_PROPERTY.DISCOUNT: // type là chiếu khấu thương mại - bớt đi giá trị
              totalTaxReduction = totalTaxReduction - item?.taxReduction
              break
            default:
              break
          }
        }
        if (item?.discountMoney) {
          switch (item?.type) {
            case PRODUCT_PROPERTY.GOODS_SERVICE: // type là hàng hoá/ dịch vụ + bình thường
            case PRODUCT_PROPERTY.SPECIAL_GOODS:
              discountMoney += item?.discountMoney
              break
            case PRODUCT_PROPERTY.PROMOTION: // type là hàng khuyến mại không + tổng tiền
              // taxMoney += item?.taxMoney;
              break
            case PRODUCT_PROPERTY.DISCOUNT: // type là chiếu khấu thương mại - bớt đi giá trị
              // discountMoney -= item?.discountMoney
              break
            default:
              break
          }
        }
      })
      if (
        values.taxRate === 'KHAC' ||
        (actionType === ACTION_TYPE.UPDATE &&
          !isChangeTaxRate &&
          !isChangeTable)
      ) {
        taxMoney = Utils.parseFormattedNumberToFloat(values.taxMoney)
      }

      discountMoney = Utils.roundNumber(
        discountMoney,
        ['VNĐ', 'VND'].includes(formik.values.currency)
          ? formatNumber?.currencyExchange
          : formatNumber?.foreignCurrency,
      )

      // total = Utils.roundNumber(total, roundingConfigDataNew('totalCost'))
      console.log('kaki', total)
      console.log('formatNumber', formatNumber)
      console.log('formik.values.currency', formik.values.currency)
      console.log(
        'formik.values.currency',
        ['VNĐ', 'VND'].includes(formik.values.currency)
          ? formatNumber?.currencyExchange
          : formatNumber?.foreignCurrency,
      )
      total = Utils.roundNumber(
        total,
        ['VNĐ', 'VND'].includes(formik.values.currency)
          ? formatNumber?.currencyExchange
          : formatNumber?.foreignCurrency,
      )
      console.log('kaki1', total)
      taxMoney = Utils.roundNumber(
        taxMoney,
        ['VNĐ', 'VND'].includes(formik.values.currency)
          ? formatNumber?.currencyExchange
          : formatNumber?.foreignCurrency,
      )
      console.log('formatNumber', formatNumber)
      console.log('taxMoney2', taxMoney)
      totalAfterTax = Utils.roundNumber(
        total - discountMoney + taxMoney - totalTaxReduction,
        // roundingConfig('totalCost'),
        // roundingConfigDataNew('totalCost'),
        ['VNĐ', 'VND'].includes(formik.values.currency)
          ? formatNumber?.currencyExchange
          : formatNumber?.foreignCurrency,
      )
      calculateAndSetFinalExchangedMoney(
        exchangeRate,
        discountMoney,
        total,
        taxMoney,
        totalAfterTax,
        totalTaxReduction,
      )
      setFieldValue('discountMoney', discountMoney)
      setFieldValue('total', total)
      console.log('totalTEs4', total)
      setFieldValue('exchangedTotal', total * exchangeRate)
      setFieldValue('taxMoney', taxMoney)
      setFieldValue('totalAfterTax', totalAfterTax)
      setFieldValue('exchangedTotalAfterTax', totalAfterTax * exchangeRate)
      setFieldValue('taxReduction', totalTaxReduction)
      setFieldValue(
        'exchangedTotalTaxReduction',
        totalTaxReduction * exchangeRate,
      )
      setIsChangeTable(false)
    },
    [
      values,
      setFieldValue,
      actionType,
      calculateAndSetFinalExchangedMoney,
      setIsChangeTable,
      roundingConfig,
      formatNumber,
      isChangeTaxRate,
      isChangeTable,
    ],
  )

  const calculateAndSetExchangedMoneyPerItem = useCallback(() => {
    let tempTableData = [...tableData]
    let exchangeRate = Utils.parseFormattedNumberToFloat(values.exchangeRate)

    // Tính toán tiền quy đổi
    let newTableData = calculateExchangedMoneyTableData(
      tempTableData,
      exchangeRate,
      formik,
      formatNumber,
    )

    setTableData(newTableData)
  }, [tableData, values.exchangeRate, setTableData])

  return { calculateAndSetFinalMoney, calculateAndSetExchangedMoneyPerItem }
}
